'use client'

import { FC } from 'react'
import { useLayoutData } from '@/context/LayoutDataContext'
import { SiteFooterContent } from '@/components/SiteFooter/SiteFooterContent'

export const SiteFooter: FC = () => {
  const { footer } = useLayoutData()

  return <SiteFooterContent {...footer} />
}
